import { render, staticRenderFns } from "./downloads_tab.vue?vue&type=template&id=678d72ec"
import script from "./downloads_tab.vue?vue&type=script&lang=js"
export * from "./downloads_tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports